import Base from '../Pages/Base'
import List from '../Pages/List'
import Form from '../Pages/Form'

export default [
	{
		path: 'links/lei-paulo-gustavo',
		component: Base,
		children: [
			{
				path: '',
				name: 'LeiPauloGustavoList',
				component: List,
				meta: {
					path: '/links/lei-paulo-gustavo',
					pai: 'Links',
					title: 'Admin - Lei Paulo Gustavo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Lei Paulo Gustavo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: 'novo',
				name: 'LeiPauloGustavoNovo',
				component: Form,
				meta: {
					path: '/links/lei-paulo-gustavo',
					pai: 'Links',
					title: 'Admin - Lei Paulo Gustavo - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Lei Paulo Gustavo',
						class: '',
						active: false,
						url: '/links/lei-paulo-gustavo'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: ':id',
				name: 'LeiPauloGustavoEditar',
				component: Form,
				meta: {
					path: '/links/lei-paulo-gustavo',
					pai: 'Links',
					title: 'Admin - Lei Paulo Gustavo - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Lei Paulo Gustavo',
						class: '',
						active: false,
						url: '/links/lei-paulo-gustavo'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			}
		]
	}
]